<!-- 知识模块的回收站 -->
<template>
  <div id="entprecyclefileTable">
    <div class="topRow">
      <el-button v-if="type==2 ? recoveryMyrecycle : ( type==3 ? recoveryEntprecycle : coveryEnterpriseDeptDocRecycle ) " class="btnBgColor" size="small"
        type="primary" @click="recovery">
        恢复
      </el-button>
      <el-button v-if="type==2 ? deleMyrecycle : ( type==3 ? deleEntprecycle:delEnterpriseDeptDocRecycle )" class="btnBgColor" size="small" type="danger"
        @click="batchDel">
        彻底删除
      </el-button>
    </div>
    <el-table ref="multipleTable" :data="list" tooltip-effect="dark" height="100%" class="tableCol" border @selection-change="selectChange">
      <template slot="empty">
        <img :src="zanwu" alt="" />
        <p style="font-size:16px;color:#000;">
          暂无数据
        </p>
      </template>
      <el-table-column type="selection" width="55" align="center">
      </el-table-column>
      <el-table-column ref="fileNameSort" show-overflow-tooltip align="left" label="文件名称" prop="folderName">
        <template slot-scope="{ row }">
          <div style="display:flex;align-items: center" class="colCheck">
            <!-- 文件的图标 -->
            <img :src="className(row)" style="flex-shrink:0;margin-right:6px" />
            <!-- 文件名称 -->
            <div :style="{
              cursor:
                cacheListContent.createFolder.folderId === 'recycle'
                  ? ''
                  : 'pointer',
            }" @click.stop="clickFolderFile(row, $event)">
              <span style="width:80%;">{{ row.folderName }}</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="260">
        <template slot-scope="scope">
          <i v-if="type==2 ? deleMyrecycle : ( type==3 ? deleEntprecycle : delEnterpriseDeptDocRecycle )" class="el el-icon-delete rowIcon" title="删除"
            @click.stop="thoroughDeleteOrRecover(scope.row, 1)"></i><i
            v-if="type==2 ? recoveryMyrecycle : ( type==3 ? recoveryEntprecycle : coveryEnterpriseDeptDocRecycle ) " class="el-icon-refresh-left rowIcon" title="恢复"
            @click.stop="thoroughDeleteOrRecover(scope.row, 2)"></i>
        </template>
      </el-table-column>
      <el-table-column prop="position" align="center" width="120" label="原路径" show-overflow-tooltip />
      <el-table-column prop="fileSize" align="center" label="文件大小" :formatter="formatterFileSize"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="删除人" prop="operUserName" width="200" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="删除时间" prop="operDate" width="200" show-overflow-tooltip>
      </el-table-column>
    </el-table>
    <recycleRenameDlg ref="recycleRenameDlg" @callback="afterRecycle"></recycleRenameDlg>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { tableRowIcon } from "@/CommonDP/utils/docPublic";
import docService from "@/CommonDP/service/doc-service";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
import secondaryMenuService from "@/CommonDP/service/secondaryMenu-service";
import recycleRenameDlg from "@/CommonDP/components/recycleRenameDlg";
export default {
  name: "Myrecycle",
  components: { recycleRenameDlg },
  props: {
    type: { default: 0, type: Number } //   2 个人文档 3企业文档 4部门文档
  },
  data() {
    return {
      cacheListContent: {
        createFolder: {}
      },
      list: [],
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      deleMyrecycle: checkPermission(this.$allPerms.MYRECYCLE_DALE),
      recoveryMyrecycle: checkPermission(this.$allPerms.MYRECYCLE_RECOVERY),
      deleEntprecycle: checkPermission(this.$allPerms.ENTPRECYCLE_DALE),
      recoveryEntprecycle: checkPermission(this.$allPerms.ENTPRECYCLE_RECOVERY),

      delEnterpriseDeptDocRecycle: checkPermission(this.$allPerms.ENTERPRISEDEPTDOCRECYCLE_DEL),
      coveryEnterpriseDeptDocRecycle: checkPermission(this.$allPerms.ENTERPRISEDEPTDOCRECYCLE_COVERY),
      renameForm: {}
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      selectArr: (state) => state.perFile.selectArr
    })
  },
  watch: {},
  created() {
    this.querlist2();
  },
  methods: {
    // 恢复
    recovery() {
      const batchArr = this.selectArr;
      if (batchArr.length === 0) {
        return this.$message.warning("请选择文件");
      }
      this.$confirm("进行批量恢复操作时候,若文件在原位置中已存在同名文件/文件夹,将对这类文件/文件夹进行跳过处理。", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        closeOnPressEscape: false

      }).then(async () => {
        const fileIdsData = this.selectArr.filter((item) => item.folderType !== 0);
        const folderIdsData = this.selectArr.filter((item) => item.folderType === 0);
        const fileIds = fileIdsData.map((item) => item.folderId);
        const folderIds = folderIdsData.map((item) => item.folderId);
        const bool = this.selectArr.some((item) => {
          return item.parentId === '0' ;
        });
        const prjId = "MyDoc";
        await docService.recyclerestore({ fileIds, folderIds, prjId, isBatch: 1 });
        await this.$message({ type: "success", message: "恢复成功" });
        this.querlist2();
        if (this.type === 4 && bool) {
          await this.$store.dispatch("setRouterNav", []);
          await this.$store.commit("saveFlatRoutes", []);
          // await this.$store.dispatch("queryEnterpriseDept");
          this.$store.dispatch("GetModuleList", this.enterpriseId);
        }
      });
    },
    // 删除功能
    async batchDel() {
      const batchArr = this.selectArr;
      if (batchArr.length === 0) {
        return this.$message.warning("请选择文件");
      }
      this.$confirm("确定删除吗?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        closeOnPressEscape: false

      }).then(async () => {
        const fileIdsData = this.selectArr.filter((item) => item.folderType !== 0);
        const folderIdsData = this.selectArr.filter((item) => item.folderType === 0);
        const fileIds = fileIdsData.map((item) => item.folderId);
        const folderIds = folderIdsData.map((item) => item.folderId);
        const prjId = "MyDoc";
        await docService.recycldelete({ fileIds, folderIds, prjId });
        this.$message({ type: "success", message: "删除成功" });
        this.querlist2();
      });
    },
    async querlist2() {
      try {
        if (this.type === 2) {
          const result = await docService.querypersonalRecycle(this.enterpriseId);
          this.list = result.data;
        } else if (this.type === 3) {
          const result = await docService.queryenterpriseRecycle(this.enterpriseId);
          this.list = result.data;
        } else if (this.type === 4) {
          const result = await secondaryMenuService.queryEnterpriseDeptRecycle(this.enterpriseId);
          this.list = result.data;
        }
      } catch (e) {
        this.$store.dispatch("perFileUpdateMessageObj", {
          isShow: true,
          message: e.message || "加载失败"
        });
      }
    },
    // 点击文件名称
    async clickFolderFile(row) {
      if (row.delPrivi) return; // 回收站文件文件夹
    },

    async thoroughDeleteOrRecover(row, type) {
      let messageType = "";
      type === 1 ? (messageType = "删除") : (messageType = "恢复");
      this.$store.dispatch("XtDesignUpdateMessageObj", {
        isShow: true,
        message: `${messageType}中...`
      });
      try {
        if (messageType === "删除") {
          this.$confirm("是否确定删除?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            closeOnClickModal: false,
            closeOnPressEscape: false
          })
            .then(async () => {
              var fileIds = [];
              var folderIds = [];
              var prjId = "MyDoc";
              if (row.folderType !== 0) {
                fileIds.push(row.folderId);
              } else {
                folderIds.push(row.folderId);
              }
              const result = await docService.recycldelete({
                fileIds,
                folderIds,
                prjId
              });
              if (result.result === "0") {
                this.querlist2();
                this.$message.success(`${messageType}成功`);
              }
            })
            .catch(() => {
              this.$store.dispatch("XtDesignUpdateMessageObj", {
                isShow: false,
                message: ""
              });
            });
        } else {
          // 恢复
          var fileIds = [];
          var folderIds = [];
          var prjId = "MyDoc";
          if (row.folderType !== 0) {
            fileIds.push(row.folderId);
          } else {
            folderIds.push(row.folderId);
          }
          const result = await docService.recyclerestore({
            fileIds,
            folderIds,
            prjId,
            isBatch: 0
          });
          if (result.result === "0") {
            if (result.data !== null) {
              this.$store.dispatch("XtDesignUpdateMessageObj", {
                isShow: false,
                message: ""
              });
              this.renameForm = result.data;
              this.renameForm.parentId = row.parentId;
              this.$refs.recycleRenameDlg.show(result.data);
            } else {
              await this.$message.success(`${messageType}成功`);
              this.querlist2();
              if (this.type === 4 && row.parentId === '0') {
                await this.$store.dispatch("setRouterNav", []);
                await this.$store.commit("saveFlatRoutes", []);
                // await this.$store.dispatch("queryEnterpriseDept");
                this.$store.dispatch("GetModuleList", this.enterpriseId);
              }
            }
          }
        }
      } catch (e) {
        this.$store.dispatch("XtDesignUpdateMessageObj", {
          isShow: false,
          message: ""
        });
      }
    },
    async afterRecycle() {
      await this.$message.success(`恢复成功`);
      this.querlist2();
      if (this.type === 4 && this.renameForm.parentId === '0') {
        await this.$store.dispatch("setRouterNav", []);
        await this.$store.commit("saveFlatRoutes", []);
        // await this.$store.dispatch("queryEnterpriseDept");
        this.$store.dispatch("GetModuleList", this.enterpriseId);
      }
    },
    formatterFileSize(row) {
      if (row.folderType !== 0) {
        if (row.fileSize === "0") return "-";
        else return row.fileSize;
      }
    },
    selectChange(selection) {
      this.$store.dispatch("perFileUpdateSelect", selection);
    },
    className(row) {
      return tableRowIcon(row);
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
#entprecyclefileTable {
  width: 100%;
  height: 100%;
  padding: 0 var(--big-space) var(--middle-space);
  display: flex;
  flex-direction: column;

  .topRow{
    padding: var(--middle-space) 0;
  }

  /deep/ .el-table {
    flex-grow: 1;
    .el-table__body-wrapper {
      .rowIcon {
        cursor: pointer;
        color: #A1C5E7;
        font-size: 16px;
        margin-right: 6px;
      }
    }

    .el-table__body-wrapper::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    .el-table__body-wrapper::-webkit-scrollbar-track {
      background: rgb(255, 255, 255);
      border-radius: 2px;
    }

    .el-table__body-wrapper::-webkit-scrollbar-thumb {
      background: #eee;
      border-radius: 10px;
    }

    .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
      background: #C4C6CC;
    }
  }
}
::v-deep span{
  font-size: 14px !important;
}
::v-deep .cell{
  font-size: 14px !important;
}
</style>
